import * as React from "react";
import {translate} from "react-i18next";
import {Image} from 'semantic-ui-react';
import {connect, Dispatch} from "react-redux";
import {AgChartsReact} from 'ag-charts-react';
// reducer
import {RouteComponentProps} from "react-router-dom";
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";
import {compose} from "redux";
import {ILocationTranslation, ITextAndIcon} from "src/components/GeneralInterfaces";
import GeneralActions from "../../redux/actions/GeneralActions";
import {IReduxState} from "src/redux/IReduxState";
import ColumnFactory from "../../services/ColumnFactory";

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {Accordion, Button, Grid, Icon, Input} from "semantic-ui-react";
import {selectBaseLinks, selectClient, selectIsEditShow, selectLanguageList, selectWorkflows} from "../../redux/selectors/generalSelectors";
import {OverviewWorld} from "src/components/kuma/OverviewWorld";
import {selectKumaExtraLinks, selectKumaReqirements} from "src/redux/selectors/kumaSelector";
import {KumaRequirementListDto, KumaViewDto, LanguageDto, MenuDto, WorkflowDto} from "src/services/Client";
import HATEOASClient, {GetNewRequirementListParams} from "src/services/HATEOASClient";
import KumaViewActions from "src/redux/actions/KumaViewActions";
import {renderErrorToast} from "src/utils/FeedbackMessageUtils";
import {createRowsForKumaRequirement} from "./KumaRowUtils";
import {
    getUniqueDataWithSeries,
    setUniqueData,
    myTheme,
    getNoOfReqVsActualityConfig,
    getMarketVsRequirementConfig,
    getRequirementByStatusConfig,
    getDistinctData
} from "src/components/kuma/ChartConfig";
import {parseWorkflowString} from "src/services/WorkflowUtils";

const createLinkName = (value: number, state: any): ITextAndIcon => {
    const {userModelyears} = state.general;
    const mj = userModelyears.elements ? userModelyears.elements.find((mjo: any) => mjo.objectId === value) : undefined;
    const sval = !mj ? value : ColumnFactory.mj2str(mj);
    return {text: "MODELYEAR_VALUE", options: {value: sval}, noTranslation: false};
};
interface IMapDispatchToProps {
    addTranslationLocation: (translation: ILocationTranslation) => void;
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    ReceivedKumaRequirementsAction: (requirements: any) => void;
}
interface IMapStateToProps {
    IsEditShow: boolean;
    client: HATEOASClient;
    requirements: any;
    baseLinks?: MenuDto;
    kumaExtraLinks?: MenuDto;
    languageList?: LanguageDto[];
    workflows?: WorkflowDto[];
}

interface IOwnProps {
}

interface IKumaManagementViewProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent, RouteComponentProps<RouteProps> {
}

interface RouteProps {
    modelyear?: string;
}

interface IKumaManagementViewState {
    activeIndex: number;
    chartOption: any;
    noOfReqVsActuality: any;
    marketVsRequirement: any;
    statusVsRequirement: any;
    marketVsTypeFamilies: any;
}

class KumaManagementView extends React.Component<IKumaManagementViewProps, IKumaManagementViewState> {

    /** message if modifiing */
    modifiingMessage?: string;

    constructor(props: IKumaManagementViewProps) {
        super(props);

        this.state = {
            activeIndex: 1,
            chartOption: {
                data: [
                    {label: 'Germany (C00)', value: 56.9},
                    {label: 'USA (C02)', value: 22.5},
                    {label: 'France (C05)', value: 6.8},
                ],
                series: [
                    {
                        type: 'pie',
                        angleKey: 'value',
                        calloutLabelKey: 'label',
                        sectorLabelKey: 'value',
                        sectorLabel: {
                            color: 'white',
                            fontWeight: 'bold',
                        },
                    },
                ],
                background: {
                    visible: false
                },
            },
            noOfReqVsActuality: null,
            marketVsRequirement: null,
            statusVsRequirement: null,
            marketVsTypeFamilies: null
        };
    }

    componentDidMount() {
        if (this.props.requirements.length === 0) {
            this.reloadData();
        } else {
            this.preparedRequirementsVsActualityData(this.props.requirements);
        }
        // add translation of the link address
        this.props.addTranslationLocation({pattern: "kuma", substitutes: "KUMA_VIEW"});
        document.body.style.overflow = 'hidden';

    }
    private preparedRequirementsVsActualityData = (requirements: KumaViewDto[]) => {
        const {t, workflows} = this.props;
        const activeRequirements = requirements.filter((req: KumaViewDto) => req.active && req.status);
        let kumaActiveWorkFlowsSteps: any = [];
        if (activeRequirements) {
            let month = 0, year = 0;
            const distinctCnrs = getDistinctData(activeRequirements, "assignedCnrs");
            const uniqueCnrs = getUniqueDataWithSeries(distinctCnrs, "cnr");
            const distinctTypeFamilies = getDistinctData(activeRequirements, "typefamilies");
            const uniqueTypeFamilies = getUniqueDataWithSeries(distinctTypeFamilies, "typefamily");
            const seriesData: any = [];
            const seriesData2: any = [];
            setUniqueData(uniqueCnrs, seriesData, "name", "cnr");
            setUniqueData(uniqueTypeFamilies, seriesData2, "name", "objectId");
            activeRequirements.map((req: KumaViewDto) => {
                if (req.metadata && req.metadata.createdTimestamp) {
                    const date = new Date(req.metadata.createdTimestamp);
                    if (date.getMonth() === new Date().getMonth()) {
                        month = month + 1;
                    }
                    if (date.getFullYear() === new Date().getFullYear()) {
                        year = year + 1;
                    }
                }
                if (req.assignedCnrs) {
                    const currentCnrs = req.assignedCnrs.map(p => p.cnr);
                    uniqueCnrs.map((cnr: any) => {
                        if (currentCnrs.includes(cnr.cnr)) {
                            const index = seriesData.findIndex((item: any) => item.id === cnr.cnr);
                            seriesData[index].value = seriesData[index].value + 1;
                        }
                    });
                }
                if (req.typefamilies) {
                    const currentTypefamilies = req.typefamilies.map(p => p.objectId);
                    uniqueTypeFamilies.map((typefamily: any) => {
                        if (currentTypefamilies.includes(typefamily.objectId)) {
                            const index = seriesData2.findIndex((item: any) => item.id === typefamily.objectId);
                            seriesData2[index].value = seriesData2[index].value + 1;
                        }
                    });
                }
                const kumaStatus: any = parseWorkflowString(req.status, workflows || []);

                if (kumaStatus) {
                    if (kumaActiveWorkFlowsSteps.length === 0) {
                        kumaStatus.workflow.status.map((status: any, index: number) => {
                            const random = Math.floor(Math.random() * 3);
                            kumaActiveWorkFlowsSteps.push({label: status.name, status: 0, objectId: status.objectId, fill: myTheme.palette.fills[random]});
                        });
                    }
                    kumaActiveWorkFlowsSteps.map((status: any) => {
                        if (status.objectId === kumaStatus.status.objectId) {
                            const index = kumaActiveWorkFlowsSteps.findIndex((item: any) => item.objectId === status.objectId);
                            kumaActiveWorkFlowsSteps[index].status = kumaActiveWorkFlowsSteps[index].status + 1;
                        }
                    });
                }
            });
            const data = {
                month,
                year,
                requirements: activeRequirements.length,
            };
            const noOfReqVsActuality = getNoOfReqVsActualityConfig(data, t);
            const marketVsRequirement = getMarketVsRequirementConfig(seriesData);
            const marketVsTypeFamilies = getMarketVsRequirementConfig(seriesData2);
            const statusVsRequirement = getRequirementByStatusConfig(kumaActiveWorkFlowsSteps, t);
            this.setState({noOfReqVsActuality, marketVsRequirement, statusVsRequirement, marketVsTypeFamilies});
        }
    }
    componentWillUnmount(): void {
        document.body.style.overflow = 'auto';
    }
    private reloadData = () => {
        if (this.props.baseLinks) {
            this.requestKumaExtraLinks(this.props.baseLinks);
        }
    }
    requestKumaExtraLinks = (baseLinks: MenuDto) => {
        if (this.props.client.GET_kumaExtraLinks(baseLinks).canExecute()) {
            this.props.client.GET_kumaExtraLinks(baseLinks).execute()
                .then((extraLinks: MenuDto) => {
                    this.requestRequirementList(extraLinks);
                })
                .catch((reason: any) => {
                    window.scrollTo(0, 0);
                    renderErrorToast({
                        message: "ERRORS:GET_KUMA_EXTRA_LINKS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }
    requestRequirementList = (extraLinks: MenuDto | undefined) => {
        if (extraLinks) {
            const {languageList, workflows} = this.props;
            if (this.props.client.GET_kumaRequirementList(extraLinks).canExecute()) {
                const params: GetNewRequirementListParams = {
                    metadata: true,
                };
                this.props.client.GET_kumaRequirementList(extraLinks).execute(params)
                    .then((data: KumaRequirementListDto) => {
                        if (data.elements && languageList && workflows) {
                            const rows = createRowsForKumaRequirement(data, languageList, workflows);
                            this.props.ReceivedKumaRequirementsAction(rows);
                        } else {
                            this.props.history.push("/kuma");
                        }
                    })
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:GET_KUMA_LIST",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            }
        }
    }
    private onAccordionClick = (e: any, titleProps: any) => {
        const {index} = titleProps;
        const {activeIndex} = this.state;
        const newIndex = activeIndex === index ? -1 : index;
        this.setState({activeIndex: newIndex});
    }
    render() {
        const {activeIndex} = this.state;
        const {t, history, IsEditShow} = this.props;
        return (
            <div className="management-view-container kuma-background">
                <div className="porsche"> <Image centered={true} src={"./images/Logos/porsche.png"} /></div>
                {IsEditShow && <Grid className="edit_market_container">
                    <Grid.Column width={16}>
                        <Button onClick={() => history.goBack()}>{t("KUMA_EDIT_MARKET_REQ")}</Button>
                    </Grid.Column>
                </Grid>}
                <div className="accordion">
                    <Input
                        className="search"
                        size="small"
                        icon={<Icon name='search' inverted={true} circular={true} link={true} />}
                        placeholder='Search...'
                    />
                    <Accordion>
                        <Accordion.Title
                            active={activeIndex === 0}
                            index={0}
                            onClick={this.onAccordionClick}
                        >
                            <div className="accordion_title">
                                <Icon name='dropdown' />
                                <span>{t("KUMA_WATCHLIST")} </span>
                                <Icon size="large" name="eye" className="right_content" />
                            </div>
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 0}>
                            <p>
                                Watchlist content
                            </p>
                        </Accordion.Content>
                        <Accordion.Title
                            active={activeIndex === 1}
                            index={1}
                            onClick={this.onAccordionClick}
                        >
                            <div className="accordion_title">
                                <Icon name='dropdown' />
                                <span>{t("KUMA_OVERALL_WORLD_VIEW")} </span>
                                <Icon size="large" name="world" className="right_content" />
                            </div>
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 1}>
                            <OverviewWorld
                                noOfReqVsActuality={this.state.noOfReqVsActuality}
                                marketVsRequirement={this.state.marketVsRequirement}
                                marketVsTypeFamilies={this.state.marketVsTypeFamilies}
                                statusVsRequirement={this.state.statusVsRequirement}
                                t={t}
                            />
                        </Accordion.Content>
                        <Accordion.Title
                            active={activeIndex === 2}
                            index={2}
                            onClick={this.onAccordionClick}
                        >
                            <div className="accordion_title">
                                <Icon name='dropdown' />
                                <span>{t("KUMA_OVERVIEW_MARKET_LEVEL")} 1 </span>
                                <Icon size="large" name="map marker alternate" className="right_content" />
                            </div>
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 2}>
                            <div className="accordion_content">
                                {this.state.chartOption && <AgChartsReact options={this.state.chartOption} />}
                            </div>
                        </Accordion.Content>
                        <Accordion.Title
                            active={activeIndex === 3}
                            index={3}
                            onClick={this.onAccordionClick}
                        >
                            <div className="accordion_title">
                                <Icon name='dropdown' />
                                <span>{t("KUMA_OVERVIEW_MARKET_LEVEL")} 2 </span>
                                <Icon size="large" name="map marker alternate" className="right_content" />
                            </div>
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 3}>
                            <p>
                                Overview Market level 2
                            </p>
                        </Accordion.Content>
                        <Accordion.Title
                            active={activeIndex === 4}
                            index={4}
                            onClick={this.onAccordionClick}
                        >
                            <div className="accordion_title">
                                <Icon name='dropdown' />
                                <span>{t("KUMA_FILTER_MARKET")}</span>
                                <Icon size="large" name="filter" className="right_content" />
                            </div>
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 4}>
                            <p>
                                Filter Market Requirement
                            </p>
                        </Accordion.Content>
                    </Accordion>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    requirements: selectKumaReqirements(state),
    IsEditShow: selectIsEditShow(state),
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),
    kumaExtraLinks: selectKumaExtraLinks(state),
    languageList: selectLanguageList(state),
    workflows: selectWorkflows(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: IKumaManagementViewProps): IMapDispatchToProps => ({
    addTranslationLocation: () => dispatch(GeneralActions.AddTranslationLocation({pattern: "kuma", substitutes: "KUMA"})),
    addLoadingMessage: (message: string) => dispatch(GeneralActions.AddLoadingMessage(message)),
    removeLoadingMessage: (message: string) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    ReceivedKumaRequirementsAction: (requirements) => dispatch(KumaViewActions.ReceivedKumaRequirementsAction(requirements))
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["KUMA_VIEW"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(KumaManagementView);



// WEBPACK FOOTER //
// ./src/views/KumaView/KumaManagementView.tsx